<form [formGroup]="form" (ngSubmit)="onSaveDeviationUrl()">
  <div class="form-group">
    <h4 class="fs-12 font-weight-bold">Deviation Register</h4>
  </div>
  <div class="form-group">
    <div class="row">
      <div class="col col-lg-12">
        <input
          type="text"
          class="form-control"
          [formControl]="url"
          placeholder="Paste URL link..."/>

        <div *ngIf="url.errors && (url.dirty || url.touched)">
          <div *ngIf="url.errors.pattern" class="invalid-feedback force-show">
            This is not a valid URL.
          </div>
        </div>
      </div>
      <ng-container *ngIf="data?.lastChangedBy">
        <div class="col col-lg-12 mt-2 fs-12">
          <strong>Last changed:</strong>
          on <strong>{{ data?.lastChanged | niceDate }}</strong>
          by <strong>{{ data?.lastChangedBy }}</strong>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="form-group mb-0">
    <button type="button" class="btn btn-outline-danger" (click)="clearDeviationForm()">
      Clear
    </button>
    <button type="submit" class="btn btn-outline-success float-lg-end" [disabled]="form.invalid">
      Save
    </button>
  </div>
</form>
